var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"facebook-login"},[_c('button',{on:{"click":_vm.buttonClicked}},[(!_vm.isConnected)?[_c('img',{attrs:{"src":require("../../../assets/facebook-logo2.svg")}})]:_vm._e(),_vm._v(" "+_vm._s(_vm.getButtonText)+" ")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }